// extracted by mini-css-extract-plugin
module.exports = {"label":"Label_label__gFsXg","requiredLabel":"Label_requiredLabel__xY28L"};